import { render } from "./main_nextcloud.vue?vue&type=template&id=7d28a388&scoped=true"
import script from "./main_nextcloud.vue?vue&type=script&lang=js"
export * from "./main_nextcloud.vue?vue&type=script&lang=js"

import "./main_nextcloud.vue?vue&type=style&index=0&id=7d28a388&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d28a388"]])

export default __exports__